import { Directive, OnInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[appCustomAutofocus]'
})
export class CustomAutofocusDirective implements OnInit {
  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.elementRef.nativeElement.focus();
  }
}
